let cartSnapshotTimer;

async function fetchCart() {
  const rootUrl = window.Shopify?.routes?.root || '/';
  const response = await fetch(`${rootUrl}cart.js`, {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) return null;
  return response.json();
}

async function submitCartSnapshot(cart) {
  if (typeof cart.token !== 'string' || !cart.token) return;

  const productsById = new Map();
  (cart.items || []).forEach((item) => {
    const productId = String(item.product_id || '');
    const variantId = String(item.variant_id || '');
    if (!/^\d+$/.test(productId) || !/^\d+$/.test(variantId)) return;

    if (!productsById.has(productId)) productsById.set(productId, new Set());
    productsById.get(productId).add(variantId);
  });

  const products = Array.from(productsById, ([product_id, variantIds]) => ({
    product_id,
    variant_ids: Array.from(variantIds),
  }));

  await fetch('/apps/bt-signals/v1/cart/snapshot', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      guest_id: window.btSignalsGetGuestId(),
      cart_token: cart.token,
      products,
    }),
  });
}

function scheduleCartSnapshot() {
  window.clearTimeout(cartSnapshotTimer);
  cartSnapshotTimer = window.setTimeout(async () => {
    try {
      const cart = await fetchCart();
      if (cart) await submitCartSnapshot(cart);
    } catch (_error) {
      // Cart signal failures must not affect cart updates.
    }
  }, 100);
}

window.addEventListener('bt:signals:cart-add', async (event) => {
  const productId = String(event.detail?.productId || '');
  if (!/^\d+$/.test(productId)) return;

  try {
    const cart = await fetchCart();
    if (!cart || typeof cart.token !== 'string' || !cart.token) return;

    await Promise.all([
      fetch('/apps/bt-signals/v1/cart/adds', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product_id: productId,
          guest_id: window.btSignalsGetGuestId(),
          cart_token: cart.token,
        }),
      }),
      submitCartSnapshot(cart),
    ]);
  } catch (_error) {
    // Cart signal failures must not affect adding products to the cart.
  }
});

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  if (event.source !== 'product-form') scheduleCartSnapshot();
});